import * as React from 'react';
import { assertNever } from 'owa-assert';
import { CalendarList } from 'owa-calendar-list';
import { EventDetails } from 'owa-event-details';
import {
    getCalendarViewType,
    getPanelViewType,
    getSelectedCalendarItemId,
} from '../selectors/timePanelStoreSelectors';
import { getTimePanelSessionId } from '../selectors/telemetrySelectors';
import { loadPanel, panelClosed } from '../actions/timePanelStoreActions';
import { observer } from 'mobx-react';
import { TimePanelSource } from '../store/schema/TimePanelStore';
import { TodoPanel } from 'owa-todos';
import { AgendaScenarioId } from '../constants';
import { ConflictsView } from 'owa-day-grid';

const styles = require('./TimePanel.scss');

export interface TimePanelProps {
    source: TimePanelSource;
}

@observer
export default class TimePanel extends React.Component<TimePanelProps> {
    componentDidMount() {
        loadPanel(this.props.source);
    }

    componentWillUnmount() {
        panelClosed();
    }

    render() {
        const panelSessionId = getTimePanelSessionId();
        const panelViewType = getPanelViewType();

        let content: JSX.Element;
        switch (panelViewType) {
            case 'Calendar':
                const viewType = getCalendarViewType();
                const selectedCalendarItemId = getSelectedCalendarItemId();
                switch (viewType) {
                    case 'List':
                        content = (
                            <CalendarList
                                source={'TimePanel'}
                                agendaScenarioId={AgendaScenarioId}
                                parentSessionId={panelSessionId}
                            />
                        );
                        break;
                    case 'EventDetails':
                        content = <EventDetails selectedCalendarItemId={selectedCalendarItemId} />;
                        break;
                    case 'Conflicts':
                        content = <ConflictsView selectedEventId={selectedCalendarItemId} />;
                        break;
                }
                break;
            case 'Tasks':
                content = (
                    <TodoPanel
                        source={'TimePanel'}
                        parentSessionId={panelSessionId}
                        hideFolderPicker={false}
                    />
                );
                break;
            default:
                assertNever(panelViewType);
        }

        return (
            <div className={styles.container}>
                <div className={styles.contentWrapper}>{content}</div>
            </div>
        );
    }
}
